import { render, staticRenderFns } from "./AuthorBox.vue?vue&type=template&id=42f3948c&scoped=true&"
import script from "./AuthorBox.vue?vue&type=script&lang=js&"
export * from "./AuthorBox.vue?vue&type=script&lang=js&"
import style0 from "./AuthorBox.vue?vue&type=style&index=0&id=42f3948c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f3948c",
  null
  
)

export default component.exports